import React from "react";

function IconTruck(data) {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={data.w}
        height={data.h}
        viewBox="0 0 50 37"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fillRule="nonzero" transform="translate(-1204 -116)">
            <g transform="translate(1089 108)">
              <g transform="translate(115 8)">
                <path
                  fill="#DFA370"
                  d="M35.815 19.698H48.693V28.491H35.815z"
                ></path>
                <path
                  fill="#3D3833"
                  d="M34.372 29.813H1.306A1.337 1.337 0 010 28.491V1.322C.012.597.59.012 1.306 0h33.066a1.315 1.315 0 011.283 1.322v27.169c0 .721-.571 1.31-1.283 1.322zm-31.76-2.645h30.453V2.691H2.612v24.477z"
                ></path>
                <path
                  fill="#3D3833"
                  d="M48.693 29.813H34.807a1.276 1.276 0 01-.917-.394 1.238 1.238 0 01-.366-.951l.32-19.164a1.314 1.314 0 011.307-1.276h5.912c.39.004.759.182 1.008.487l7.653 9.79c.172.245.268.536.275.836v9.28c.013.361-.119.712-.364.974a1.322 1.322 0 01-.942.418zm-12.557-2.645h11.251v-7.586l-6.966-8.98h-3.987l-.298 16.566z"
                ></path>
                <ellipse
                  cx="10.403"
                  cy="28.537"
                  fill="#DFA370"
                  stroke="#3D3833"
                  strokeLinejoin="round"
                  strokeWidth="3.436"
                  rx="5.018"
                  ry="5.081"
                ></ellipse>
                <ellipse
                  cx="40.054"
                  cy="29.419"
                  fill="#DFA370"
                  stroke="#3D3833"
                  strokeLinejoin="round"
                  strokeWidth="3.436"
                  rx="5.018"
                  ry="5.081"
                ></ellipse>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }

export default IconTruck;
